import {
  BoosterAction,
  LOAD_BOOSTER_BENCHMARK,
  LOAD_BOOSTER_BENCHMARK_FAIL,
  LOAD_BOOSTER_BENCHMARK_SUCCESS,
  LoadBoosterBenchmark,
  LoadBoosterBenchmarkSuccess,
  SET_BOOSTER_STATS, SetBoosterStats
} from "../actions";

export interface IBoosterStats {
  notCompressed: number;
  notCompressedFull: number;
  notCompressedSize: number;
  reducedSize: number;
  reducedPercent: number;
  lastCompressedSize: number;
  lastCompressedPercent: number;
  compressedFull: number;
  compressedThumbs: number;
  compressedOther: number;
  pagesCompressed: Array<any>;
  compressIsRunning: boolean;
  planLimit: number;
  limitResetDate: any;
  usedCountFromLimit: number;
}

export interface IBoosterPagesCompressed {
  pageId: number;
  imagesCount: number;
}

export interface IBoosterClearCacheStats {
  cacheEnabled: boolean;
  cacheDate: number;
}

export interface IBoosterBenchmark {
  serverPerformance: number;
  wordpressPerformance: number;
  phpVersion: number;
  mysqlVersion: number;
}

export interface IBoosterEntityState {
  loading: boolean;
  loaded: boolean;
  stats: IBoosterStats;
  clearCacheStats: IBoosterClearCacheStats;
  benchmark: IBoosterBenchmark;
}

export interface IBoosterState {
  entities: {[websiteId: number]: IBoosterEntityState};
  loading: boolean;
  loaded: boolean;
}

export const initialState: IBoosterState = {
  entities: {},
  loading: false,
  loaded: false
};

export function reducer(state: IBoosterState = initialState, action: BoosterAction): IBoosterState {
  let payload: any;

  switch (action.type) {

    case SET_BOOSTER_STATS:
      payload = (<SetBoosterStats>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            stats: payload.stats
          }
        }
      };

    case LOAD_BOOSTER_BENCHMARK:
      payload = (<LoadBoosterBenchmark>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: true,
            loaded: false,
          }
        }
      };

    case LOAD_BOOSTER_BENCHMARK_SUCCESS:
      payload = (<LoadBoosterBenchmarkSuccess>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            benchmark: payload.benchmark,
            loading: false,
            loaded: true,
          }
        }
      };

    case LOAD_BOOSTER_BENCHMARK_FAIL:
      payload = (<LoadBoosterBenchmark>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true,
          }
        }
      };

  }

  return state;
}
